<template>
  <div>
    <a-modal
      class="rename-box"
      :title="$t(`tips.tip71`)"
      centered
      :visible="tipVisible"
      :cancelText="$t(`button.cancel`)"
      :okText="$t(`button.downloadPC`)"
      @cancel="handleCancel"
      @ok="handleOk"
    >
      <div style="text-align: center; padding: 15px 24px; font-size: 16px">
        {{ $t(`tips.tip47`) }}
      </div>
    </a-modal>
  </div>
</template>
<script>
import { message } from "ant-design-vue";
import {
  defineComponent,
  watch,
  getCurrentInstance,
  toRefs,
  reactive,
} from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  setup(props, context) {
    const { proxy } = getCurrentInstance();
    let globalProperties =
      getCurrentInstance().appContext.config.globalProperties;
    const router = useRouter();
    const state = reactive({
      tipVisible: false,
    });

    const show = () => {
      state.tipVisible = true;
    };

    const handleOk = () => {
      state.tipVisible = false;

      let routeData = router.resolve({
        name: "download",
      });
      window.open(routeData.href, "_blank");
    };

    const handleCancel = () => {
      state.tipVisible = false;
    };

    return {
      ...toRefs(state),
      handleCancel,
      handleOk,
      show,
    };
  },
});
</script>
